import { Theme } from '@mui/material/styles';
import createStyles from '@mui/styles/createStyles';
import makeStyles from '@mui/styles/makeStyles';

import { colorsPalette, LARGE_MARGIN, MIDDLE_MARGIN, SMALL_MARGIN } from '../../theme';

const useStyles = (background) =>
  makeStyles((theme: Theme) =>
    createStyles({
      wrapper: {
        paddingTop: MIDDLE_MARGIN,
        paddingBottom: MIDDLE_MARGIN,
        background: theme.palette.secondary.dark,
        [theme.breakpoints.up('md')]: {
          paddingTop: LARGE_MARGIN,
          paddingBottom: LARGE_MARGIN,
          backgroundColor:
            background === 'Dark' ? theme.palette.secondary.dark : theme.palette.secondary.light,
        },
      },
      container: {
        display: 'flex',
        flexDirection: 'column',
        [theme.breakpoints.up('md')]: {
          flexDirection: 'row',
          alignItems: 'center',
        },
      },
      textWrapper: {
        flex: 1,
        marginBottom: MIDDLE_MARGIN,
        [theme.breakpoints.up('md')]: {
          paddingRight: MIDDLE_MARGIN,
          marginBottom: 0,
        },
        [theme.breakpoints.up('xl')]: {
          paddingRight: LARGE_MARGIN,
        },
      },
      titleLink: {
        color: colorsPalette.white,
      },
      title: {
        fontSize: 24,
        lineHeight: '28px',
        marginBottom: SMALL_MARGIN,
        [theme.breakpoints.up('md')]: {
          fontSize: 28,
          lineHeight: '34px',
          marginBottom: SMALL_MARGIN / 2,
        },
      },
      description: {
        fontSize: 16,
        lineHeight: '24px',
        color: colorsPalette.gray,
        [theme.breakpoints.up('md')]: {
          lineHeight: '28px',
        },
      },
      imgWrapper: {
        flex: 1,
        position: 'relative',
        display: 'flex',
        justifyContent: 'center',
        [theme.breakpoints.up('md')]: {
          paddingLeft: MIDDLE_MARGIN,
          justifyContent: 'flex-end',
        },
        [theme.breakpoints.up('xl')]: {
          paddingLeft: LARGE_MARGIN,
        },
      },
      img: {
        maxWidth: '100%',
        width: 470,
      },
    }),
  );

export default useStyles;
